import { BlockReference, BlockReferenceArray } from '@/cms/types/block';
import { BlockComponentModel } from '@/cms/types/blok-component';

import { RichTextFieldStrapiProps } from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';

import ScrapingTemplateLibrary from '.';
import { ScrapingTemplateCardProps } from './Components/ScrapingTemplateCard';

export type ScrapingTemplateLibraryStrapiProps = BlockComponentModel<{
  scraping_template_library: BlockReference<{
    title: RichTextFieldStrapiProps;
    description: RichTextFieldStrapiProps;
    scraping_template_cards: BlockReferenceArray<ScrapingTemplateCardProps>;
  }>;
}>;

const ScrapingTemplateLibraryStrapi = (
  props: ScrapingTemplateLibraryStrapiProps
) => {
  return (
    <ScrapingTemplateLibrary
      scrapingTemplateCards={
        props.block.scraping_template_library.data?.attributes
          .scraping_template_cards
      }
      theme={props.theme}
      title={props.block.scraping_template_library.data?.attributes.title}
      description={
        props.block.scraping_template_library.data?.attributes.description
      }
    />
  );
};

export default ScrapingTemplateLibraryStrapi;
